import * as React from 'react';
import { Theme, makeStyles, createStyles, useTheme } from '@material-ui/core';
import { NewDateRangePickerProps, NewDateRangePicker } from './NewDateRangePicker';

const useStyles = (theme: Theme) =>
    makeStyles(
        createStyles({
            input: {
                fontSize: theme.typography.pxToRem(24),
                fontWeight: theme.typography.fontWeightBold as number,
                padding: theme.spacing(0.7, 0, 0.8),
            },
            root: {
                '&:after': {
                    borderBottomColor: theme.palette.secondary.main,
                },
                '&:before': {
                    borderBottomColor: theme.palette.primary.main,
                    borderBottomWidth: 2,
                },
                '&:hover': {
                    '&:before': {
                        borderBottomColor: `${theme.palette.secondary.main} !important`,
                    },
                },
            },
        }),
    )();

/**
 * This hook is used to theme the new date range picker component to fit our common color scheme
 * It returns a ClassNameMap for an Input MUI component.
 * (Note: We can't import ClassNameMap extraneously, hence the ReturnType type used here)
 *
 * @returns A ClassNameMap object for input and root MUI classes
 */
function useDSThemeClasses(): ReturnType<typeof useStyles> {
    const theme = useTheme();
    const classes = useStyles(theme);
    return classes;
}

export function ThemedNewDateRangePicker(props: NewDateRangePickerProps): JSX.Element {
    const dsClasses = useDSThemeClasses();
    return <NewDateRangePicker {...props} inputPropsClasses={dsClasses} />;
}
